import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faGear,
  faLayerGroup,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Col } from "reactstrap";
import { PulseLoader } from "react-spinners";
import Swal from "sweetalert2";

import { APISD } from "../../../../../../../config/apisd";
import ToastError from "../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";

import "bulma/css/bulma.css";
import "../../../../../../../index.css";

// const pageStyles = `
//   .fase-search-section {
//     margin-bottom: 14px;
//   }

//   .fase-table {
//     min-width: 760px;
//   }

//   .fase-table .fase-col-number {
//     width: 78px;
//   }

//   .fase-table .fase-col-name {
//     width: 22%;
//   }

//   .fase-table .fase-col-description {
//     width: auto;
//   }

//   .fase-table .fase-col-config {
//     width: 150px;
//     text-align: center !important;
//   }

//   .fase-table .fase-col-action {
//     width: 130px;
//     text-align: center !important;
//   }

//   .fase-name-text,
//   .fase-description-text {
//     display: block;
//     width: 100%;
//     line-height: 1.5;
//     white-space: normal;
//     overflow-wrap: break-word;
//     word-break: normal;
//   }

//   .fase-name-text {
//     color: #24314e;
//     font-size: 13px;
//     font-weight: 700;
//   }

//   .fase-description-text {
//     color: #69758f;
//     font-size: 13px;
//     font-weight: 500;
//   }

//   .fase-config-button {
//     display: inline-flex;
//     min-width: 94px;
//     height: 34px;
//     align-items: center;
//     justify-content: center;
//     gap: 7px;
//     padding: 0 12px;
//     border: 1px solid #d9e3ff;
//     border-radius: 9px;
//     background: #eef3ff;
//     color: #315fc5;
//     font-size: 12px;
//     font-weight: 700;
//     white-space: nowrap;
//     transition:
//       background-color 0.2s ease,
//       border-color 0.2s ease,
//       transform 0.2s ease;
//   }

//   .fase-config-button:hover {
//     border-color: #b9c9ff;
//     background: #e7eeff;
//     color: #284fa7;
//     transform: translateY(-1px);
//   }

//   .fase-config-button:focus {
//     outline: none;
//     box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.1);
//   }

//   @media (max-width: 780px) {
//     .fase-table {
//       min-width: 720px;
//     }

//     .fase-page .page-header-top {
//       align-items: flex-start !important;
//       flex-direction: column;
//       gap: 14px;
//     }

//     .fase-page .page-header-top .ml-auto {
//       width: 100%;
//       margin-left: 0 !important;
//     }

//     .fase-page .module-header-button {
//       width: 100%;
//       justify-content: center;
//     }
//   }
// `;

export default function Fase() {
  document.title = "Fase";

  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level") || "developer";
  const navigate = useNavigate();

  const [getData, setGetData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFetching, setIsFetching] = useState(false);

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [id, setId] = useState("");
  const [dataUpdate, setDataUpdate] = useState(null);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const GetResponseData = useCallback(async () => {
    setIsFetching(true);

    const requestBody = {
      page: 1,
      limit: 1000,
      ascending: true,
      search: "",
      level: storageLevel,
    };

    try {
      const response = await APISD.get("/api/fases", {
        ...fetchParams,
        params: requestBody,
        data: requestBody,
      });

      if (response?.status === 200) {
        setGetData(response?.data?.data || []);
      }
    } catch (error) {
      setGetData([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data fase",
      });
    } finally {
      setIsFetching(false);
    }
  }, [fetchParams, storageLevel]);

  useEffect(() => {
    GetResponseData();
  }, [GetResponseData]);

  const deleteById = (faseId) => {
    Swal.fire({
      title: "Apakah kamu yakin?",
      text: "Data yang dihapus tidak dapat dikembalikan.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await APISD.delete(
            `/api/fases/${faseId}`,
            fetchParams
          );

          if (response?.data?.error) {
            throw new Error(response?.data?.message);
          }

          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error?.response?.data?.message ||
              error?.message ||
              "Gagal menghapus data"
          );

          return false;
        }
      },
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      ToastSuccess.fire({
        icon: "success",
        title: "Data berhasil dihapus",
      });

      GetResponseData();
    });
  };

  const nameCollator = useMemo(
    () =>
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      }),
    []
  );

  const filteredData = useMemo(() => {
    const keyword = searchKeyword.trim().toLowerCase();
    const source = Array.isArray(getData) ? getData : [];

    const rows = !keyword
      ? source
      : source.filter((item) => {
          const nameFase = String(item?.name_fase || "").toLowerCase();
          const description = String(item?.description || "").toLowerCase();

          return (
            nameFase.includes(keyword) ||
            description.includes(keyword)
          );
        });

    return [...rows].sort((first, second) =>
      nameCollator.compare(
        String(first?.name_fase || "").trim(),
        String(second?.name_fase || "").trim()
      )
    );
  }, [getData, nameCollator, searchKeyword]);

  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));
    return pages > 0 ? pages : 1;
  }, [rowsPerPage, totalRows]);

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword]);

  useEffect(() => {
    if (tablePage > totalPages) {
      setTablePage(totalPages);
    }

    if (tablePage < 1) {
      setTablePage(1);
    }
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const start = (tablePage - 1) * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, rowsPerPage, tablePage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let page = 1; page <= totalPages; page += 1) {
        pages.push(page);
      }

      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (let page = left; page <= right; page += 1) {
      if (page !== 1 && page !== totalPages) {
        pages.push(page);
      }
    }

    if (right < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages.filter(
      (value, index, array) => array.indexOf(value) === index
    );
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const safePage = Math.min(
      Math.max(1, Number(nextPage) || 1),
      totalPages
    );

    setTablePage(safePage);
  };

  const viewModalUpdate = (faseId, fase) => {
    setId(faseId);
    setDataUpdate(fase);
    setModalUpdate(true);
  };

  const navigateGrade = (fase) => {
    const faseName = fase?.name_fase || fase?.slug_name || "fase";

    navigate(
      `/matpels/fase/grade/${fase?.id}/${encodeURIComponent(faseName)}`
    );
  };

  const startRow =
    totalRows === 0
      ? 0
      : Math.min((tablePage - 1) * rowsPerPage + 1, totalRows);

  const endRow = Math.min(tablePage * rowsPerPage, totalRows);

  return (
    <div className="body sims-page">
      {/* <style>{pageStyles}</style> */}

      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          dataUpdate={dataUpdate}
          show={modalUpdate}
          onHide={() => {
            setModalUpdate(false);
            setId("");
            setDataUpdate(null);
          }}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faLayerGroup} />
            </span>

            <h4 className="page-title-text">Fase</h4>
          </div>

          <div className="ml-auto">
            <button
              type="button"
              onClick={() => setModalAdd(true)}
              className="btn btn-create sims-header-button"
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>Tambah Fase</span>
            </button>
          </div>
        </div>

        <nav
          aria-label="breadcrumb"
          className="sims-breadcrumb-nav mt-4"
        >
          <ol className="sims-breadcrumb">
            <li className="sims-breadcrumb-item">
              <Link to="/matpels">Mata Pelajaran</Link>
            </li>

            <li className="sims-breadcrumb-separator">/</li>

            <li
              className="sims-breadcrumb-item active"
              aria-current="page"
            >
              Fase
            </li>
          </ol>
        </nav>
      </div>

      <div className="body-content sims-content">
        {isFetching ? (
          <div className="sims-loading">
            <PulseLoader color="#3f5bea" size={12} />
          </div>
        ) : (
          <Col xl="12" sm="12" className="sims-column">
            <div className="sims-search-wrap mb-3">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="sims-search-icon"
              />

              <input
                type="text"
                className="sims-search-input"
                placeholder="Cari nama fase atau deskripsi..."
                value={searchKeyword}
                onChange={(event) => setSearchKeyword(event.target.value)}
              />
            </div>

            <div className="sims-table-card">
              <div className="sims-table-scroll">
                <table className="sims-table ">
                  <thead>
                    <tr>
                      <th className="sims-col-number">
                        No
                      </th>
                      <th style={{width: "15%"}}>Fase</th>
                      <th >Deskripsi</th>
                      <th style={{width: "25%"}}>Tingkatan</th>
                      <th className="sims-col-action">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((row, index) => (
                        <tr key={row?.id || index}>
                          <td className="sims-col-number">
                            <span className="sims-number-badge">
                              {(tablePage - 1) * rowsPerPage + index + 1}
                            </span>
                          </td>

                          <td>
                            <span className="sims-text-bold">
                              {row?.name_fase || "-"}
                            </span>
                          </td>

                          <td>
                            <span>
                              {row?.description || "-"}
                            </span>
                          </td>

                          <td >
                            <button
                              type="button"
                              className="sims-table-button"
                              onClick={() => navigateGrade(row)}
                              title="Atur tingkatan"
                            >
                              <FontAwesomeIcon icon={faGear} />
                              Config
                            </button>
                          </td>

                          <td className="sims-col-action">
                            <div className="sims-action-wrap">
                              <button
                                type="button"
                                className="sims-action-button sims-action-edit"
                                onClick={() =>
                                  viewModalUpdate(row?.id, row)
                                }
                                title="Ubah fase"
                                aria-label={`Ubah ${row?.name_fase || "fase"}`}
                              >
                                <FontAwesomeIcon icon={faPenToSquare} />
                              </button>

                              <button
                                type="button"
                                className="sims-action-button sims-action-delete"
                                onClick={() => deleteById(row?.id)}
                                title="Hapus fase"
                                aria-label={`Hapus ${row?.name_fase || "fase"}`}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="sims-empty-state">
                          <div className="sims-empty-state-content">
                            Data tidak ditemukan
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {filteredData.length > 0 && (
                <div className="sims-pagination">
                  <div className="sims-pagination-left">
                    <span className="sims-page-info">
                      Menampilkan <b>{startRow}</b>-<b>{endRow}</b> dari{" "}
                      <b>{totalRows}</b> data
                    </span>

                    <select
                      className="sims-page-size"
                      value={rowsPerPage}
                      onChange={(event) => {
                        const value = Number(event.target.value) || 10;
                        setRowsPerPage(value);
                        setTablePage(1);
                      }}
                    >
                      <option value={10}>10 / halaman</option>
                      <option value={25}>25 / halaman</option>
                      <option value={50}>50 / halaman</option>
                      <option value={100}>100 / halaman</option>
                    </select>
                  </div>

                  <div className="sims-pagination-right">
                    <button
                      type="button"
                      className="sims-page-nav"
                      onClick={() => goToPage(tablePage - 1)}
                      disabled={tablePage <= 1}
                      aria-label="Halaman sebelumnya"
                    >
                      <FontAwesomeIcon icon={faChevronLeft} />
                      <span>Sebelumnya</span>
                    </button>

                    <div className="sims-page-numbers">
                      {pageNumbers.map((page, index) =>
                        page === "..." ? (
                          <span
                            key={`dots-${index}`}
                            className="sims-page-dots"
                          >
                            ...
                          </span>
                        ) : (
                          <button
                            type="button"
                            key={`page-${page}`}
                            className={`sims-page-number ${
                              page === tablePage ? "active" : ""
                            }`}
                            onClick={() => goToPage(page)}
                          >
                            {page}
                          </button>
                        )
                      )}
                    </div>

                    <button
                      type="button"
                      className="sims-page-nav"
                      onClick={() => goToPage(tablePage + 1)}
                      disabled={tablePage >= totalPages}
                      aria-label="Halaman berikutnya"
                    >
                      <span>Selanjutnya</span>
                      <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </Col>
        )}
      </div>
    </div>
  );
}
